module.exports = __webpack_public_path__ + "img/icon38.01e481b7.png";